// @ts-check
export default class SwishStatsModel {
  /**
   * @param {import('./interface').TSwishStats} data - raw api outcome data
   */
  constructor(data) {
    /**
     * Line
     * @type {number}
     */
    this.line = data.l;
    /**
     * Over odd
     * @type {string}
     */
    this.overOdd = String(data.oo);
    /**
     * Long id for "Over odd"
     * @type {string}
     */
    this.overLongId = data.mpid ? `sw_${data.mpid}_over` : `sw_${data.mmid}_over`;
    /**
     * Under odd
     * @type {string}
     */
    this.underOdd = String(data.uo);
    /**
     * Long id for "Under odd"
     * @type {string}
     */
    this.underLongId = data.mpid ? `sw_${data.mpid}_under` : `sw_${data.mmid}_under`;
    /**
     * Stats ID
     * @type {number}
     */
    this.statsId = data.sid;
    /**
     * Swish match ID
     * @type {number}
     */
    this.matchId = data.sm;
  }
}